import GlobalStyles from '@mui/material/GlobalStyles';
import { useGetProfile } from 'api/profile/getUserProfile/getUserProfile';
import { AnimatePresence } from 'framer-motion';
import { useAtom } from 'jotai';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { isMobileBurgerMenuOpenAtom } from 'store/private/layout/layoutAtoms';

import { BodyBorder } from '../../../styles/GlobalStyle';
import { BottomBar } from '../BottomBar/BottomBar';
import { MobileBurgerMenu } from '../MobileBurgerMenu/MobileBurgerMenu';
import { PageTemplate } from '../PageTemplate/PageTemplate';
import { Sidebar } from '../Sidebar/Sidebar';

export const AppLayout = () => {
  const [isMobileBurgerMenuOpen, setIsMobileBurgerMenuOpen] = useAtom(
    isMobileBurgerMenuOpenAtom,
  );

  const { getProfile } = useGetProfile();

  const { pathname } = useLocation();
  useEffect(() => {
    if (isMobileBurgerMenuOpen) setIsMobileBurgerMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    getProfile();
  }, []);

  return (
    <>
      <Sidebar />
      <BottomBar />

      <AnimatePresence>
        {isMobileBurgerMenuOpen ? <MobileBurgerMenu /> : null}
      </AnimatePresence>

      <PageTemplate>
        <GlobalStyles styles={BodyBorder} />
        <Outlet />
      </PageTemplate>
    </>
  );
};
